@if (form; as form) {
  <div class="row" [formGroup]="form">
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"firstName" as controlName'>
        <label [for]='"correspondence" + controlName'>
          Imię/Imiona *
        </label>
        <input
          [id]='"correspondence" + controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          [formControlName]='controlName'
          placeholder='Wpisz tu imię/imiona'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"lastName" as controlName'>
        <label [for]='"correspondence" + controlName'>
          Nazwisko *
        </label>
        <input
          [id]='"correspondence" + controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu nazwisko'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"phone" as controlName'>
        <label [for]='"correspondence" + controlName'>
          Numer telefonu *
        </label>
        <input
          mask='0*'
          [id]='"correspondence" + controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu numer telefonu'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"email" as controlName'>
        <label [for]='"correspondence" + controlName'>
          E-mail *
        </label>
        <input
          [id]='"correspondence" + controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu e-mail'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"zipCode" as controlName'>
        <label [for]='"correspondence" + controlName'>
          Kod pocztowy *
        </label>
        <input
          [id]='"correspondence" + controlName'
          mask='00-000'
          [dropSpecialCharacters]='false'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu kod pocztowy'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"postOffice" as controlName'>
        <label [for]='"correspondence" + controlName'>
          Poczta
        </label>
        <input
          [id]='"correspondence" + controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu pocztę'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"city" as controlName'>
        <label [for]='"correspondence" + controlName'>
          Miejscowość *
        </label>
        <input
          [id]='"correspondence" + controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu miejscowość'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"street" as controlName'>
        <label [for]='"correspondence" + controlName'>
          Ulica *
        </label>
        <input
          [id]='"correspondence" + controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu nazwę ulicy'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-2'>
      <div class='form-group' *ngIf='"buildingNumber" as controlName'>
        <label [for]='"correspondence" + controlName'>
          Nr domu *
        </label>
        <input
          [id]='"correspondence" + controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu nr domu'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-2'>
      <div class='form-group' *ngIf='"apartmentNumber" as controlName'>
        <label [for]='"correspondence" + controlName'>
          Nr mieszkania
        </label>
        <input
          [id]='"correspondence" + controlName'
          [formControlName]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          placeholder='Wpisz tu nr mieszkania'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
  </div>
}
